import { cn } from '@/lib/utils'

interface DefaultAvatarProps {
  className?: string
  label?: string
}

export function DefaultAvatar({ className, label = '默认头像' }: DefaultAvatarProps) {
  return (
    <span
      role="img"
      aria-label={label}
      className={cn(
        'bg-primary/10 text-primary flex h-full w-full items-center justify-center overflow-hidden rounded-full',
        className,
      )}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 64 64"
        className="h-[72%] w-[72%]"
        fill="none"
        focusable="false"
      >
        <circle cx="32" cy="24" r="10" fill="currentColor" fillOpacity="0.92" />
        <path
          d="M16 52c2.8-10.2 8.6-15.3 16-15.3S45.2 41.8 48 52"
          fill="currentColor"
          fillOpacity="0.72"
        />
        <path
          d="M20.5 50.5c3-6.8 6.8-10.2 11.5-10.2s8.5 3.4 11.5 10.2"
          stroke="white"
          strokeOpacity="0.55"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    </span>
  )
}
